export const caseStudies = [
  {
    id: 1,
    client: 'Arnold Construction',
    industry: 'Construction',
    icon: 'ri-building-4-line',
    engagement: 'Website Modernization & Operational Visibility Infrastructure',
    challenge:
      'Their digital infrastructure no longer reflected the full scale of the organization\'s operational capabilities, divisions, and long-term experience. The website lacked visibility into newer departments and created limited inbound lead generation opportunities.',
    implementation: [
      'Full website redevelopment and modernization',
      'Showcased 100+ years of operational capabilities',
      'Structured updated department and service pages',
      'Implemented a lead intake survey for inbound opportunities',
      'Improved user flow and operational credibility online',
    ],
    outcomes: [
      { metric: '300%', label: 'Increase in inbound lead activity within 3 months' },
      { metric: '$8M', label: 'Potential project opportunity supported by improved visibility' },
    ],
    longTermImpact:
      'The engagement expanded into discussions surrounding custom software development opportunities focused on operational optimization within the safety department, including workflow and reporting system enhancements.',
    tags: ['Website Development', 'Operational Visibility', 'Lead Generation', 'Construction'],
  },
  {
    id: 2,
    client: 'DynaCon',
    industry: 'Construction & Operations',
    icon: 'ri-user-star-line',
    engagement: 'Executive Search & Operational Leadership Infrastructure',
    challenge:
      'The organization required a high-level operational leader capable of supporting division growth, operational management, bidding strategy, and long-term departmental scalability within a department valued at approximately $10 million.',
    implementation: [
      'Targeted executive search for director-level operational leadership',
      'Evaluated leadership alignment and management capabilities',
      'Supported operational growth objectives and strategic hiring alignment',
      'Coordinated executive-level recruitment support',
    ],
    outcomes: [
      { metric: '$10M', label: 'Department value supported by placed director-level leader' },
      { metric: '1', label: 'Director-level placement supporting overseas operational expansion' },
    ],
    longTermImpact:
      'The placement supported DynaCon\'s continued operational expansion strategy and strengthened leadership infrastructure within a high-value operational division.',
    tags: ['Executive Search', 'Operational Leadership', 'Division Growth', 'Infrastructure Hiring'],
  },
  {
    id: 3,
    client: 'Texas Dewatering',
    industry: 'Infrastructure & Construction',
    icon: 'ri-team-line',
    engagement: 'Executive Search & Workforce Growth Infrastructure',
    challenge:
      'As the organization scaled operations, leadership required high-level personnel capable of supporting estimating, operational oversight, safety management, and organizational growth across multiple departments.',
    implementation: [
      'Chief Estimator recruitment and placement',
      'Senior operational personnel identification',
      'Safety leadership recruitment',
      'Workforce infrastructure support',
      'Leadership alignment and candidate evaluation',
    ],
    outcomes: [
      { metric: '$30M→$60M', label: 'Revenue growth over a two-year period supported by leadership expansion' },
      { metric: '3+', label: 'Critical leadership roles filled across estimating, operations, and safety' },
    ],
    longTermImpact:
      'The engagement established Mainframe Solutions as an ongoing workforce infrastructure and executive search partner supporting operational growth and leadership alignment. Leadership growth and operational support contributed to the company\'s continued expansion trajectory from approximately $30 million to $60 million in revenue over a two-year period.',
    tags: ['Executive Search', 'Workforce Infrastructure', 'Safety Leadership', 'Growth Support Strategy'],
  },
];